import { Component, Vue } from 'vue-property-decorator'

import Loader from '@/components/Loader/index.vue'

import fetch from '@/helpers/fetch'
import store from '@/store/store.js'


@Component({
	components: {
		Loader,
	},
})
export default class LoginGoogleSuccess extends Vue {
	async mounted() {
		const res = await fetch.get(
			'/api/login/google/success?' + this.$route.fullPath.split('?')[1],
		)

		Object.assign(store.user, res.data)
		localStorage.setItem('user', JSON.stringify(res.data))

		let currentFullPath = localStorage.currentFullPath

		if (!currentFullPath || currentFullPath[0] !== '/') {
			currentFullPath = '/'
		}

		this.$router.push(currentFullPath || '/')
	}
}
